import {Navigate, useNavigate} from "react-router-dom";
import Dashboard from "./components/dashboard/Dashboard";
import HomePage from "./components/home/HomePage";
import SurveyIndex from "./components/survey/survey-index/survey-index";
import SurveyCreate from "./components/survey/survey-create/survey-create";
import ReportIndex from "./components/reports/report-index";
import DisplaySurvey from "./components/survey/survey-index/survey-show/DisplaySurvey";
import ResponsesReport from "./PBI/ResponsesReport";
import MyReport from "./PBI/Report";
import TakeSurvey from "./components/survey/survey-index/survey-take/TakeSurvey";
import RespondSurvey from "./components/RespondSurvey";
import RespondSurveyBata from "./components/survey-response/bata-response/RespondSurveyBata";
import RespondSignInRequired from "./components/RespondSignInRequired";
import UserProfile from "./components/user/user-profile";
import CollectIndex from "./components/survey/share-components/collect/collect-index";
import Billing from "./components/billing/billing-index";
import {useIsAuthenticated} from "@azure/msal-react";
import SurveyDashboard from "./charts/components/main/SurveyDashboard";
import {useRoutesGuard} from "./guards";
import RespondSurveyRecruitment from "./components/survey-response/recruitment-response/RespondSurveyRecruitment";
import SurveyRespondents from "./components/survey-response/survey-respondents/SurveyRespondents";
import SurveyValuesProfile from "./charts/components/main/SurveyDashboardOverview/SurveyValuesProfile";
import RespondSurveyRecruitmentTests
    from "./components/survey-response/recruitment-response/RespondSurveyRecruitmentTests";
import RespondSurveyRecruitmentDev from "./components/survey-response/recruitment-response/RespondSurveyRecruitmentDev";

// const BREAKPOINTS = {mobile: 0, tablet: 768, desktop: 1280};

const AppRouting = ({t}) => {
    const isAuthenticated = useIsAuthenticated();
    // const {breakpoint} = useBreakpoint(BREAKPOINTS, 'desktop');
    let routes = [];
    if (isAuthenticated) {
        routes = [
            {
                path: '/',
                element: <HomePage/>,
                // guards: [useStripeGuard],
                // redirect: '/billing'
            },
            {
                path: 'dashboard',
                element: <Dashboard/>
            },
            {
                path: 'surveys',
                element: <SurveyIndex/>,
                // guards: [useStripeGuard],
            },
            {
                path: 'collect/:id',
                element: <CollectIndex/>,
                // guards: [useStripeGuard],
            },
            {
                path: 'takeSurvey/:id',
                element: <TakeSurvey t={t}/>,
            },
            {
                path: 'surveys-show/:id',
                element: <DisplaySurvey t={t}/>,
                // guards: [useStripeGuard],
            },
            {
                path: 'r/sirq/:id',
                element: <RespondSignInRequired t={t}/>
            },
            {
                path: 'report/:id',
                element: <ResponsesReport t={t}/>,
                // guards: [useStripeGuard],
            },
            {
                path: 'myreport/:id',
                element: <MyReport t={t}/>,
                // guards: [useStripeGuard],
            },
            {
                path: 'myreporttest/:id',
                //element: <ResponsesSurveyReport t={t} breakpoint={breakpoint}/>
                element: <SurveyDashboard/>,
                // guards: [useStripeGuard],
            },
            {
                path: 'reports',
                element: <ReportIndex/>
            },
            {
                path: 'survey-create/*',
                element: <SurveyCreate t={t}/>,
                // guards: [useStripeGuard],
            },
            {
                path: 'user-profile',
                element: <UserProfile t={t}/>,
                // guards: [useStripeGuard],
            },
            {
                path: 'billing',
                element: <Billing t={t}/>
            },
        ];
    } else {
        routes = [
            {
                path: '/',
                element: <HomePage/>
            },
            /*{
                path: 'collect/:id',
                element: <CollectIndex/>
            },*/
            {
                path: 'takeSurvey/:id',
                element: <TakeSurvey t={t}/>
            },
            /*{
                path: 'surveys-show/:id',
                element: <DisplaySurvey t={t}/>
            },*/
            {
                path: 'surveys',
                element: <SurveyIndex/>
            },
            {
                path: 'report/:id',
                element: <ResponsesReport t={t}/>
            },
            /*{
                path: 'myreporttest/:id',
                element: <ResponsesSurveyReport t={t} breakpoint={breakpoint}/>
            },*/
            // TODO delete this routes in the future: just for demo purposes Grupo Premier
            {
                path: 'surveys/respondents/:surveyId',
                element: <SurveyRespondents />,
            },
            {
                path: 'surveys/values-profile/:surveyId',
                element: <SurveyValuesProfile />,
            },
            {
                path: '*',
                element: <Navigate to="/"/>//<RedirectRoute to="/"/>
            },
        ];
    }
    routes.push({
        path: 'r/:id',
        element: <RespondSurvey t={t} navigate={useNavigate()}/>
    })
    // routes for different external customers
    routes.push({
        path: 'r-bata/:id',
        element: <RespondSurveyBata t={t} navigate={useNavigate()}/>
    })
    // Router for recruitment surveys with applicant id
    routes.push({
        path: 'r-recruitment-applicant/:id/:applicant_id',
        element: <RespondSurveyRecruitment t={t} navigate={useNavigate()}/>
    })
    // Router for recruitment surveys DEV with applicant id
    routes.push({
        path: 'r-recruitment-applicant-dev/:id/:applicant_id',
        element: <RespondSurveyRecruitmentDev t={t} navigate={useNavigate()}/>
    })
    // TODO delete this routes in the future: just for demo purposes Grupo Premier
    // this route to complete surveys many times
    routes.push({
        path: 'r-tests/:id/:applicant_id',
        element: <RespondSurveyRecruitmentTests t={t} navigate={useNavigate()}/>
    })

    return useRoutesGuard(routes);
    // return useRoutes(routes);
}

export default AppRouting;